import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';
import { IconType } from 'react-icons';

export const wrapIcon = (WrappedIcon: IconType) =>
  React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
    <Icon as={WrappedIcon} aria-hidden="true" {...props} ref={ref} />
  ));
